// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"244def4d","498":"2ed99fc3","703":"b5a91892"}[chunkId] + ".chunk.js";
};